import { queries } from '@/shared/lib/tanstack-query/query-keys'
import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'

export const useProductDetail = (id: string) => {
  const { data, isPending } = useQuery(queries.products.detail(id))
  const isBrandProduct = useMemo(
    () => !data?.mainCategory.name.includes('식품'),
    [data],
  )

  return {
    data,
    isPending,
    isBrandProduct,
  }
}
